/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemMonthDayInputFormat } from './formPagePropertyItemMonthDayInputFormat';
import { FormPagePropertyItemStringConvertRule } from './formPagePropertyItemStringConvertRule';
import { FormPagePropertyItemMonthDayErrorMessage } from './formPagePropertyItemMonthDayErrorMessage';


/**
 * 月日型の入力項目を表す。 月日型の注意点としては、以下の点。 1) 文字種変換は自動で全角 -> 半角を設定する 2) バリデーションは年月日型同様 format: date を利用。年はうるう年である2000年入力扱いでバリデーションする 
 */
export interface FormPagePropertyItemMonthDay { 
    /**
    * フォーム入力項目大種別
    */
    propertyType: 'monthDay';
    /**
    * 入力項目ID
    */
    propertyId: string;
    /**
    * 項目名(管理機能のopenapiではdisplay_name）
    */
    name: string;
    /**
    * 項目のコメント(管理機能のopenapiではdisplay_comment）
    */
    comment?: string;
    /**
    * 注意書き・凡例(管理機能のopenapiではcaution）
    */
    note?: string;
    /**
    * 必須/任意のラベルを表示するかどうか.
    */
    displayRequiredLabel: boolean;
    stringConvertRule?: FormPagePropertyItemStringConvertRule;
    type: FormPagePropertyItemMonthDay.TypeEnum;
    format: FormPagePropertyItemMonthDay.FormatEnum;
    inputFormat: FormPagePropertyItemMonthDayInputFormat;
    errorMessage?: FormPagePropertyItemMonthDayErrorMessage;
}

export namespace FormPagePropertyItemMonthDay {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
    export type FormatEnum = 'date';
    export const FormatEnum = {
        Date: 'date' as FormatEnum
    };
}


